import { EnumScheduleType } from '../../../../../../../types/generated-types';
import { DayOfWeek } from '../../types';

// Get days of the week to display tabs for, depending on the schedule type
export function daysToDisplay(
  selectedScheduleType: EnumScheduleType,
): DayOfWeek[] {
  if (selectedScheduleType === EnumScheduleType.Custom) {
    return Object.values(DayOfWeek);
  } else if (selectedScheduleType === EnumScheduleType.WeekdayWeekend) {
    return [DayOfWeek.MO, DayOfWeek.SU];
  } else {
    return [DayOfWeek.SU];
  }
}
